import { render, staticRenderFns } from "./NourishHeader.vue?vue&type=template&id=49a28ba2&scoped=true"
import script from "./NourishHeader.vue?vue&type=script&lang=js"
export * from "./NourishHeader.vue?vue&type=script&lang=js"
import style0 from "./NourishHeader.vue?vue&type=style&index=0&id=49a28ba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a28ba2",
  null
  
)

export default component.exports